import React, { Fragment } from 'react';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from './Breadcrumbs';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexFlow: 'column nowrap',
    '& > div:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
  paper: {
    padding: isMobile ? theme.spacing(1) : theme.spacing(2),
    display: 'flex',
    flexFlow: 'column nowrap',
    '& > *:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
  header: {
    display: 'flex',
    flexFlow: 'row nowrap',
    justifyContent: 'space-between',
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
    '& > div': {
      marginBottom: theme.spacing(1),
    },
  },
  headerTitle: {},
  headerDescription: {
    color: theme.palette.secondary.light,
    marginTop: theme.spacing(0.5),
  },
  actions: {
    flexGrow: 1,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& > button': {
      margin: theme.spacing(0, 0.5),
    },
  },
}));

const TwoCards = ({
  title,
  secondaryTitle,
  children,
  category,
  secondaryCategory,
  secondaryContent,
  actions,
  breadcrumbs = true,
}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {breadcrumbs && <Breadcrumbs title={title} />}
      <Grid container direction="row" spacing={1}>
        <Grid item xs={12} lg={9}>
          <div className={classes.main}>
            <Paper className={classes.paper}>
              <Grid
                container
                direction="row"
                spacing={1}
                justify="space-between"
              >
                <Grid item xs={12} lg={8}>
                  <div className={classes.title}>
                    {title ? (
                      <Typography
                        className={classes.headerTitle}
                        component="h1"
                        variant="h1"
                      >
                        {title}
                      </Typography>
                    ) : null}
                    {category ? (
                      <div className={classes.headerDescription}>
                        {category}
                      </div>
                    ) : null}
                  </div>
                </Grid>
                <Grid item xs={12} lg={4}>
                  <div className={classes.actions}>{actions}</div>
                </Grid>
              </Grid>
              <Divider className={classes.divider} />
              <div className={classes.body}>{children}</div>
            </Paper>
          </div>
        </Grid>
        <Grid item xs={12} lg={3}>
          <div className={classes.secondary}>
            <Paper className={classes.paper}>
              <div className={classes.header}>
                <div className={classes.title}>
                  {secondaryTitle ? (
                    <Typography
                      className={classes.headerTitle}
                      component="h1"
                      variant="h1"
                    >
                      {secondaryTitle}
                    </Typography>
                  ) : null}
                  {secondaryCategory ? (
                    <div className={classes.headerDescription}>
                      {secondaryCategory}
                    </div>
                  ) : null}
                </div>
              </div>
              {secondaryTitle && <Divider className={classes.divider} />}
              <div className={classes.body}>{secondaryContent}</div>
            </Paper>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
export default React.memo(TwoCards);
